export const replaceMultipleSpaces = (val: any) => {
  if (val && typeof val === 'string') {
    return val.replace(/\s\s+/g, ' ');
  }
  return null;
};

export const restrictSpecialCharacterFn = (event: any) => {
  // const enableSpecialCharacters = ['stt-qa', 'qa', 'dev'].includes(process.env.REACT_APP_ENV || '')
  const enableSpecialCharacters = true;

  const regex = new RegExp('^[a-zA-Z0-9 ]+$');
  if (enableSpecialCharacters && !regex.test(event.key)) {
    event.preventDefault();
    return false;
  }
};

export const usernameCharacterValidationFn = (event: any) => {
  // const enableSpecialCharacters = ['stt-qa', 'qa', 'dev'].includes(process.env.REACT_APP_ENV || '')
  const enableSpecialCharacters = true;
  const regex = new RegExp('^[a-zA-Z0-9.@_]+$');
  const atCount = (event.target.value.match(new RegExp('@', 'g')) || []).length;
  const underscoreCount = (event.target.value.match(new RegExp('_', 'g')) || []).length;
  const key = event.key;

  const restrictIfTrue =
    !regex.test(key) || (key === '@' && atCount >= 1) || (key === '_' && underscoreCount >= 1);

  if (enableSpecialCharacters && key !== 'Backspace' && restrictIfTrue) {
    event.preventDefault();
    return false;
  }
};

export const nameValidation = (name: string) => {
  const regex = new RegExp('^[a-zA-Z0-9 ]+$');

  if (!name || !regex.test(name)) return false;

  return true;
};

export const userNameValidation = (value: string) => {
  const regex = new RegExp('^[a-zA-Z0-9.@_]+$');
  const atCount = (value.match(new RegExp('@', 'g')) || []).length;
  const underscoreCount = (value.match(new RegExp('_', 'g')) || []).length;

  if (!value || atCount > 1 || underscoreCount > 1 || !regex.test(value)) return false;

  return true;
};
